import { AxiosResponse } from 'axios';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';

export const useFetchDeps = <T,>(
  f: (deps) => Promise<AxiosResponse<T>>,
  deps: any[] = [],
  initialState?: T
): [T | undefined, Dispatch<SetStateAction<T | undefined>>] => {
  const [state, setState] = useState<T | undefined>(initialState);

  useEffect(() => {
    f(deps).then((response) => setState(response.data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return [state, setState];
};
